import Entity from './entity'
export default class Gasequipment extends Entity<number>{
    Id:number;
    status:Number=1;
    ftId:Number;
    wId:Number;
    fId:Number;
    gId:Number;
    gas_type:Number;
    updateInterval:Number;
    Isoxygen:Number;
    Iscarbondioxide:Number;
    Isnitrogen:Number;
    Ischlorinehydride:Number;
    Iscarbonicoxide:Number;
    isoxygen:Number;
    iscarbondioxide:Number;
    isnitrogen:Number;
    ischlorinehydride:Number;
    iscarbonicoxide:Number;
    AcquisitionInterval:number;
    Numbler;
}